import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { bool, func, arrayOf, object, string } from 'prop-types'
import { Helmet } from 'react-helmet'

import Arrow from './assets/menu-arrow.svg'
import Post from './assets/post.svg'
import Plus from './assets/plus.svg'

import HoverMenu from './HoverMenu'
import SectionPopUp from '../../common/Modals/SectionPopUp'
import { getCategory, getBannerDropdown } from '../../modules/Home'

import './Menu.scss'

class Menu extends Component {
  componentWillMount() {
    this.props.getCategory()
    this.props.getBannerDropdown()
  }

  render() {
    const {
      mouseEnter,
      mouseLeave,
      onHoverMenu,
      category,
      isLoggedIn,
      banners,
    } = this.props

    return (
      <div className='menu__wrap visible-m visible-l'>
        <div className='container'>
          <div className='row'>
            <div className='rl-cl-l-6 rl-cl-m-6'>
              <ul className='main__menu__list list-unstyled list-inline'>
                <li>
                  <div className='main__menu' onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}>
                    <a>
                      <span>
                        <img className='arrow' src={Arrow} alt='kategori menu' />
                      </span>Kategori
                    </a>
                    {onHoverMenu && category &&
                    <HoverMenu data={category} banners={banners} onMouseLeave={mouseLeave} />}
                  </div>
                </li>
                <li>
                  <NavLink to='/about' className='sub__menu'>
                    Tentang Kami
                  </NavLink>
                </li>
                <li>
                  {' '}
                  <SectionPopUp section='contactus'>
                    <a className='sub__menu'>Hubungi Kami</a>
                  </SectionPopUp>
                </li>
              </ul>
            </div>
            {isLoggedIn && (
              <div className='rl-cl-l-6 rl-cl-m-6'>
                <ul className='side__menu__list list-unstyled list-inline text-right'>
                  <li>
                    <NavLink to='/user/add/infomina' className='sub__side'>
                      <span>
                        <img className='icon' src={Post} alt='buat post menu' />
                      </span>
                      Buat Post
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to='/user/add/pasarmina' className='sub__side'>
                      <span>
                        <img className='icon' src={Plus} alt='pasang iklan menu' />
                      </span>
                      Pasang Iklan
                    </NavLink>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
        {onHoverMenu && (
          <Helmet>
            <body className='overlay__body' />
          </Helmet>
        )}
      </div>
    )
  }
}

Menu.defaultProps = {
  onHoverMenu: false,
  categoryRequest: false,
  categoryError: '',
  category: null,
  isLoggedIn: false,
  banners: [],
}

Menu.propTypes = {
  onHoverMenu: bool,
  categoryRequest: bool,
  categoryError: string,
  category: arrayOf(object),
  banners: arrayOf(object),
  isLoggedIn: bool,
  mouseEnter: func.isRequired,
  mouseLeave: func.isRequired,
  getCategory: func.isRequired,
  getBannerDropdown: func.isRequired,
}

const mapStateToProps = state => ({
  categoryRequest: state.home.categoryRequest,
  categoryError: state.home.categoryError,
  category: state.home.category,
  banners: state.home.bannerDropdown,
  isLoggedIn: state.user.isLoggedIn,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getCategory,
      getBannerDropdown,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(Menu)



// WEBPACK FOOTER //
// ./src/common/Menu/Menu.js